import React, { useContext, useEffect, useState } from "react";
import { Variant } from "../../types.ts";
import { getVariation } from "../../../../../misc/helpers.ts";
import { OrderContext } from "../../OrderContext.tsx";
import { styled } from "styled-components";
import IconVerified from '../../../../../assets/images/icon-verified.svg?react';
import { bp } from '../../../../../styles/breakPoints.tsx';
import { useAppTranslation } from "../../../../../translations/useAppTranslation.ts";

const SelectedProductContainer = styled.div<{ $activeDiscount: boolean }>`
  position: sticky;
  top: 0;
  z-index: 10;
  padding: 16px;
  margin: 0 16px;
  margin-top: -20px;
  border-radius: 0px 0px 4px 4px;
  background: ${({ $activeDiscount }) => $activeDiscount ? 'var(--Lumme, #004107)' : 'var(--Secondary-Laventeli, #DECCFF)'};
  color: ${({ $activeDiscount }) => $activeDiscount ? 'var(--Valkoinen, #fff)' : '#4B4D4E'};

  box-shadow: 0px 4px 25px 0px rgba(209, 209, 209, 0.25);

  @media ${bp.sm} {
    padding: 24px 36px;
  }

  .product-name {
    color: ${({ $activeDiscount }) => $activeDiscount ? 'var(--Valkoinen, #fff)' : '#4B4D4E'};
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .change-button {
    background: transparent;
    border: none;
    color: ${({ $activeDiscount }) => $activeDiscount ? 'var(--Valkoinen, #fff)' : '#4B4D4E'};
    text-decoration: underline;
    padding: 0;
  }

  .discount-header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;

    .product-name {
      color: ${props => props.$activeDiscount ? 'var(--Valkoinen)' : 'var(--Varjo)'};
      font-weight: 700;
      cursor: pointer;
      border: none;
    }
  }

  .discount-summary {
    padding-top: 20px;
    display: flex;
    flex-direction: column;

    @media ${bp.md} {
      flex-direction: row;
      justify-content: space-between;
    }

    button {
      margin-top: 20px;
      align-self: flex-end;

      @media ${bp.md} {
        margin-top: 0;
      }
    }

    .disocunt-row {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 20px;
      color: var(--Lime, #C0E300);
      font-size: 14px;
      font-weight: 700;

      p {
        margin: 0;
        padding: 0;
      }
    }

    .price-rows {
      font-size: 14px;
    }
  }
`;

function SelectedProduct({showChangeButton = true}: {showChangeButton: boolean}) {

  const { t, db_t } = useAppTranslation();
  const { formValues, products, toPhase, discountInfo } = useContext(OrderContext);
  const [selectedProduct, setSelectedProduct] = useState<Variant | undefined>(getVariation({ products, contractTemplateId: formValues['product'] }));
  const [isSpot, setIsSpot] = useState(false);

  const [showProductInfo, setShowProductInfo] = useState(false);

  useEffect(() => {
    const product = getVariation({ products, contractTemplateId: formValues['product'] });
    setSelectedProduct(product);

    if (product) {
      setIsSpot(product.name.includes('rssis'));
    } else {
      setIsSpot(false);
    }
  }, [formValues['product']]);

  const resetProduct = () => {
    toPhase(2, true);
  }

  return (
    <React.Fragment>
      {selectedProduct ? 
      <SelectedProductContainer $activeDiscount={discountInfo?.valid === true}>
        <div className="discount-header-row">
          {t('phaseThree.yourChoice')}
          <span className="product-name" onClick={() => setShowProductInfo(!showProductInfo)}>
            {(discountInfo?.valid && !showProductInfo) && <IconVerified height={30} width={30} />}
            {db_t(selectedProduct, 'name')}
          </span>
        </div>
        {showProductInfo && <div className="discount-summary">
          <div>
            {discountInfo?.valid && discountInfo.campaign_text &&<div className="disocunt-row">
              <IconVerified height={30} width={30} /> 
              <div dangerouslySetInnerHTML={{ __html: db_t(discountInfo, 'campaign_text') }}></div>
            </div>}
            <div className="price-rows">
              <div>{t('common.monthlyPrice')}: <b>{selectedProduct?.monthly_price} {t('common.€/month')}</b></div>
              <div>{t('common.energyPrice')}: <b>{isSpot ? 'SPOT + ' : ''} {selectedProduct?.energy_price} {t('common.c/kWh')}</b></div>
            </div>
          </div>
          {showChangeButton && <button type="button" className="change-button" onClick={resetProduct}>{t('phaseThree.change')}</button>}
        </div>}
        </SelectedProductContainer>: null}
    </React.Fragment>
  )
}

export default SelectedProduct;